<template>
  <nav v-if="hasLinks" class="auth-login__legal-links" aria-label="Legal agreements">
    <a
      v-if="termsLink"
      class="auth-login__legal-link"
      :href="termsLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </a>
    <a
      v-if="privacyLink"
      class="auth-login__legal-link"
      :href="privacyLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>
    <a
      v-if="consentLink"
      class="auth-login__legal-link"
      :href="consentLink"
      target="_blank"
      rel="noopener noreferrer"
    >
      Patient Consent
    </a>
  </nav>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  termsLink:   { type: String, default: '' },
  privacyLink: { type: String, default: '' },
  consentLink: { type: String, default: '' },
})

const hasLinks = computed(() =>
  Boolean(props.termsLink || props.privacyLink || props.consentLink)
)
</script>
